module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Login",
            "field": "usr_login_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "First Name",
            "field": "usr_first_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Last Name",
            "field": "usr_last_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Role",
            "field": "usr_role_id",
            "optionListApiUrl": '/userroles/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Active",
            "field": "usr_active",
            "type": "boolean",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Filter Active Contracts",
            "field": "usr_filter_active",
            "type": "boolean",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()])]
      }
    }, {
      key: "ExtraOptions",
      fn: function(props) {
        return [(_vm.privUser) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (_vm.isReadOnly) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalSetPassword.show()
            }
          }
        }, [_vm._v("Set Password")]) : _vm._e()], 2) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('b-modal', {
    ref: "modalSetPassword",
    attrs: {
      "title": "Set Password"
    },
    on: {
      "ok": _vm.okPassword
    }
  }, [_c('b-form', {
    ref: "pwform",
    staticClass: "col-md-6 offset-md-2",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "data-vv-as": "PW1",
      "name": "pw1"
    },
    model: {
      value: (_vm.pw1),
      callback: function($$v) {
        _vm.pw1 = $$v
      },
      expression: "pw1"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "password",
      "data-vv-as": "PW2",
      "name": "pw2"
    },
    model: {
      value: (_vm.pw2),
      callback: function($$v) {
        _vm.pw2 = $$v
      },
      expression: "pw2"
    }
  }), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.pw1 !== _vm.pw2
    }
  }, [_vm._v("Passwords do not match")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-247a6176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/Detail.vue
// module id = 695
// module chunks = 1